const NOTIF_API_BASE = "https://alerta-maceio-api-production.up.railway.app/api";

const NOTIF_CONFIG = {
  friend_request: { icon: "user-plus", textKey: "notifFriendRequestText" },
  friend_accepted: { icon: "user-check", textKey: "notifFriendAcceptedText" },
  community_joined: { icon: "users", textKey: "notifCommunityJoinedText", withCommunity: true },
  community_join_request: { icon: "user-plus", textKey: "notifJoinRequestText", withCommunity: true },
  community_join_accepted: { icon: "circle-check", textKey: "notifJoinAcceptedText", withCommunity: true, noActor: true, suffixKey: "notifJoinAcceptedSuffix" },
  community_join_rejected: { icon: "circle-x", textKey: "notifJoinRejectedText", withCommunity: true, noActor: true, suffixKey: "notifJoinRejectedSuffix" },
  community_invited: { icon: "mail-plus", textKey: "notifInvitedText", withCommunity: true },
  content_reported: { icon: "flag", textKey: "notifContentReportedText", withCommunity: true, noActor: true },
  community_new_post: { icon: "message-square", textKey: "notifNewPostText", withCommunity: true },
};

function notifTimeAgo(ms) {
  const diff = Date.now() - ms;
  const min = Math.floor(diff / 60000);
  if (min < 1) return "agora";
  if (min < 60) return `${min}min`;
  const h = Math.floor(min / 60);
  if (h < 24) return `${h}h`;
  const d = Math.floor(h / 24);
  return `${d}d`;
}

function NotificacoesScreen({ lang, onUnreadChange, onNotificationClick }) {
  const { Icon } = window.VigiALDesignSystem_ff2dec;
  const deviceId = window.getDeviceId ? window.getDeviceId() : null;
  const [verifiedEmail, setVerifiedEmail] = React.useState(undefined);
  const [notifications, setNotifications] = React.useState([]);
  const [loading, setLoading] = React.useState(true);

  React.useEffect(() => {
    if (!deviceId) return;
    fetch(`${NOTIF_API_BASE}/device-trust/mine`, {
      method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify({ deviceId }),
    })
      .then((r) => r.json())
      .then((d) => setVerifiedEmail(d.verifiedEmail || null))
      .catch(() => setVerifiedEmail(null));

    fetch(`${NOTIF_API_BASE}/notifications/mine`, {
      method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify({ deviceId }),
    })
      .then((r) => r.json())
      .then((data) => {
        if (data && data.linked) {
          setNotifications(data.notifications || []);
          if (data.unreadCount > 0) {
            fetch(`${NOTIF_API_BASE}/notifications/mark-read`, {
              method: "POST", headers: { "Content-Type": "application/json" },
              body: JSON.stringify({ deviceId }),
            }).then(() => { if (onUnreadChange) onUnreadChange(0); }).catch(() => {});
          }
        }
        setLoading(false);
      })
      .catch(() => setLoading(false));
  }, []);

  if (verifiedEmail === undefined || loading) {
    return <div style={{ padding: 14, fontSize: "var(--text-sm)", color: "var(--color-text-muted)" }}>{t(lang, "comLoading")}</div>;
  }

  if (!verifiedEmail) {
    return (
      <div style={{ padding: 14 }}>
        <div style={{ fontSize: "var(--text-sm)", color: "var(--color-text-secondary)" }}>{t(lang, "notifNeedsVerifiedEmail")}</div>
      </div>
    );
  }

  return (
    <div style={{ padding: 14, flex: 1, overflowY: "auto" }}>
      {notifications.length === 0 && (
        <div style={{ fontSize: "var(--text-sm)", color: "var(--color-text-muted)" }}>{t(lang, "notifEmpty")}</div>
      )}
      {notifications.map((n) => {
        const cfg = NOTIF_CONFIG[n.type] || NOTIF_CONFIG.friend_request;
        const clickable = !!onNotificationClick && (
          n.type === "friend_request" || n.type === "friend_accepted"
          || ((n.type === "community_joined" || n.type === "community_join_request" || n.type === "community_invited" || n.type === "community_join_accepted" || n.type === "content_reported" || n.type === "community_new_post") && n.communityId)
        );
        return (
          <div
            key={n.id}
            onClick={clickable ? () => onNotificationClick(n) : undefined}
            style={{
              display: "flex", alignItems: "flex-start", gap: 10, border: "1px solid var(--color-border)", borderRadius: "var(--radius-lg)",
              padding: 10, marginBottom: 8, cursor: clickable ? "pointer" : "default",
            }}
          >
            <div style={{ width: 30, height: 30, borderRadius: "50%", background: "var(--color-brand-tint)", display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0 }}>
              <Icon name={cfg.icon} size={14} color="var(--color-brand-deep)" />
            </div>
            <div style={{ minWidth: 0, flex: 1 }}>
              <div style={{ fontSize: "var(--text-sm)", color: "var(--color-text-primary)" }}>
                {!cfg.noActor && <strong>{n.actorName || n.actorEmail}</strong>}{!cfg.noActor && " "}
                {t(lang, cfg.textKey)}{cfg.withCommunity && <React.Fragment> <strong>{n.communityName}</strong></React.Fragment>}
                {cfg.suffixKey && <React.Fragment> {t(lang, cfg.suffixKey)}</React.Fragment>}
              </div>
              <div style={{ fontSize: 10, color: "var(--color-text-muted)", fontFamily: "var(--font-mono)", marginTop: 2 }}>{notifTimeAgo(n.createdAt)}</div>
            </div>
            {clickable && <Icon name="chevron-right" size={14} color="var(--color-text-muted)" style={{ flexShrink: 0, marginTop: 8 }} />}
          </div>
        );
      })}
    </div>
  );
}
window.NotificacoesScreen = NotificacoesScreen;
